'use client';

import { LinkPagination } from '@components/pagination';

interface BlogPaginationProps {
  currentPage: number;
  totalPages: number;
  category: string;
}

export function BlogPagination({
  currentPage,
  totalPages,
  category,
}: BlogPaginationProps) {
  const generatePageUrl = (page: number): string => {
    if (category === 'latest') {
      if (page === 1) {
        // For page 1 of latest, use the main blog page
        return '/journal';
      } else {
        // For other pages of latest, use the paginated route
        return `/journal/page/${page}`;
      }
    } else {
      if (page === 1) {
        // For page 1, use the main topic page
        return `/journal/topic/${category}`;
      } else {
        // For other pages, use the paginated route
        return `/journal/topic/${category}/page/${page}`;
      }
    }
  };

  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="flex justify-center mt-12">
      <LinkPagination
        totalPages={totalPages}
        currentPage={currentPage}
        generatePageUrl={generatePageUrl}
        navAriaLabel="Blog pagination"
        pagesAriaLabel="Go to page"
      />
    </div>
  );
}
